const PILLS = [
  { icon: "\u{1F3EB}", label: "Private K-12 schools" },
  { icon: "\u{1F4B3}", label: "Credit, debit & ACH" },
  { icon: "\u{1F512}", label: "PCI-DSS compliant" },
  { icon: "\u{1F4C5}", label: "Automated billing" },
];

export default function Logos() {
  return (
    <section className="trust-bar">
      <div className="container">
        <p>Purpose-built for schools</p>
        <ul className="trust-pills">
          {PILLS.map((p) => (
            <li key={p.label} className="trust-pill">
              <span className="pill-icon">{p.icon}</span>
              {p.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
